exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav {\n    width: 50%;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n}\n\n.nav ul {\n    list-style: none;\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    flex-wrap: nowrap;\n}\n\n.nav ul li {\n    padding: 0 2%;\n}\n\n.nav a {\n    text-decoration-line: none;\n    color: black;\n    transition: .5s ease;\n}\n\n.nav a:hover {\n    opacity: .5;\n}", ""]);

// exports
